import { RouterProvider } from "react-router-dom";

import { ThemeProvider } from "./providers/ThemeProvider";
import { router } from "./router";

/**
 * Application root. ThemeProvider applies the active colour scheme globally;
 * AuthProvider is scoped to the authenticated shell (see router.tsx) so the
 * public /login route renders without it.
 */
export function App() {
  return (
    <ThemeProvider>
      <RouterProvider router={router} />
    </ThemeProvider>
  );
}
